import { Dispatch, MiddlewareAPI } from 'redux';
import { LocationChangeAction, LocationChangePayload } from 'connected-react-router';

import { getAreaFromPathname } from 'core/navigation';
import { commonActions } from 'store/common/actions';
import { RootState } from 'store/rootReducer';

export interface PageChangePayload extends LocationChangePayload {
  lastPathname?: string;
  lastArea?: string;
  nextArea?: string;
  areaChanged: boolean;
}

const pageChangeMiddleware = ({ dispatch, getState }: MiddlewareAPI<any, RootState>) => (next: Dispatch) => async (action: LocationChangeAction) => {
  next(action);

  if (action.type !== commonActions.LOCATION_CHANGE) {
    return;
  }

  const { path: { lastPathname } } = getState();

  if (lastPathname !== action.payload.location.pathname) {
    const lastArea = getAreaFromPathname(lastPathname);
    const nextArea = getAreaFromPathname(action.payload.location.pathname);
    const areaChanged = lastArea !== nextArea;

    const pageChangePayload: PageChangePayload = {
      ...action.payload,
      lastPathname,
      lastArea,
      nextArea,
      areaChanged,
    };

    dispatch({
      type: commonActions.PATH_LOCATION_CHANGE,
      payload: pageChangePayload,
    });

    if (areaChanged) {
      dispatch({
        type: commonActions.AREA_LOCATION_CHANGE,
        payload: pageChangePayload,
      });
    }
  }
};

export default pageChangeMiddleware;
